// extracted by mini-css-extract-plugin
module.exports = {"marginSmall":"1rem","finishRegistration":"PhoneConfirmation_finishRegistration__1vPHX","spaceBottomContainer":"PhoneConfirmation_spaceBottomContainer__2BxI9"};